"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineBreakFilter = void 0;
const interweave_1 = require("interweave");
const utils_1 = require("./utils");
class LineBreakFilter extends interweave_1.Filter {
    constructor(options = { type: 'all' }) {
        super();
        this.options = options;
    }
    node(_, node) {
        var _a, _b, _c, _d, _e, _f, _g;
        const { type } = this.options;
        if (node.nodeName === 'BR') {
            // Remove all line-breaks
            if (type === 'all') {
                return null;
            }
            if (type === 'collapse') {
                // adding aria attr to avoid reading "empty group" when VoiceOver is ON
                node.setAttribute('aria-hidden', 'true');
                // If the previous node is not a text node or is a line-break,
                // remove it only if the node before the previous node is not a text node.
                // This preserves natural line-breaks.
                if (((0, utils_1.isTextNode)((_a = node.previousSibling) === null || _a === void 0 ? void 0 : _a.nodeType) === false ||
                    ((_b = node.previousSibling) === null || _b === void 0 ? void 0 : _b.nodeName) === 'BR') &&
                    (0, utils_1.isTextNode)((_d = (_c = node.previousSibling) === null || _c === void 0 ? void 0 : _c.previousSibling) === null || _d === void 0 ? void 0 : _d.nodeType) === false) {
                    return null;
                }
                // if the line-break is after a list element and before an empty text
                // node containing only \t, remove the line-break
                // e.g. <ul><li>item<ul><li>subitem</li></ul><br>\t\t</li></ul><br>\t
                if (['UL', 'OL'].includes(((_e = node.previousSibling) === null || _e === void 0 ? void 0 : _e.nodeName) || '') &&
                    (0, utils_1.isTextNode)((_f = node.nextSibling) === null || _f === void 0 ? void 0 : _f.nodeType) &&
                    /^\t+$/g.test(((_g = node.nextSibling) === null || _g === void 0 ? void 0 : _g.nodeValue) || '')) {
                    return null;
                }
            }
        }
        return node;
    }
}
exports.LineBreakFilter = LineBreakFilter;
//# sourceMappingURL=LineBreakFilter.js.map